import {
  addDoc,
  collection,
  deleteDoc,
  doc,
  getDoc,
  getDocs,
  orderBy,
  query,
  updateDoc,
  where,
} from "firebase/firestore";
import { db, GroupRef } from "../../../../firebase";

export const getAllGroups = async () => {
  try {
    const q = query(GroupRef, orderBy("createdAt", "desc"));
    return await getDocs(q);
  } catch (error) {
    console.log("Error fetching groups:", error.message);
    return null;
  }
};

export const getGroupById = async (id) => {
  try {
    return await getDoc(doc(db, "group", id));
  } catch (error) {
    console.log("Error fetching group:", error.message);
    return null;
  }
};

export const addGroup = async (data) => {
  const ref = collection(db, "group");
  return await addDoc(ref, data);
};

export const updateGroup = async (id, patch) => {
  const ref = doc(db, "group", id);
  return await updateDoc(ref, patch);
};

export const deleteGroup = async (id) => {
  const ref = doc(db, "group", id);
  return await deleteDoc(ref);
};

export const groupsSearch = (array, keyword) => {
  const searchTerm = keyword.toLowerCase();
  return (array || []).filter((value) => {
    return (
      (value.name && value.name.toLowerCase().match(new RegExp(searchTerm, "g"))) ||
      (value.id && value.id.toLowerCase().match(new RegExp(searchTerm, "g")))
    );
  });
};

export const getFilterGroups = async (
  dateRange,
  statusFilterOptions,
  setLoading,
  handleFilterModalClose
) => {
  setLoading(true);

  try {
    const queries = [];

    if (statusFilterOptions && statusFilterOptions.length > 0) {
      // For now, we treat status filter as OR across selected values.
      // Firestore doesn't support OR easily without composite indexes; we do separate queries and merge.
      const statuses = statusFilterOptions;
      const promises = statuses.map(async (status) => {
        const q = query(GroupRef, where("status", "==", status.toLowerCase()));
        const snap = await getDocs(q);
        return snap.docs.map((d) => ({ id: d.id, ...d.data() }));
      });

      const results = (await Promise.all(promises)).flat();
      const dedup = new Map();
      results.forEach((r) => dedup.set(r.id, r));

      let filtered = Array.from(dedup.values());

      if (dateRange?.startDate && dateRange?.endDate) {
        filtered = filtered.filter((g) => {
          const seconds = g.createdAt?.seconds;
          if (!seconds) return false;
          const created = new Date(seconds * 1000);
          return created >= dateRange.startDate && created <= dateRange.endDate;
        });
      }

      handleFilterModalClose();
      return filtered;
    }

    if (dateRange?.startDate && dateRange?.endDate) {
      queries.push(where("createdAt", ">=", dateRange.startDate));
      queries.push(where("createdAt", "<=", dateRange.endDate));
    }

    const q = queries.length > 0 ? query(GroupRef, ...queries) : query(GroupRef);
    const snap = await getDocs(q);
    handleFilterModalClose();
    return snap.docs.map((d) => ({ id: d.id, ...d.data() }));
  } catch (error) {
    console.error("Error filtering groups:", error);
    return [];
  } finally {
    setLoading(false);
  }
};

